import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ShopOrderDetailComponent } from '../shop-order-detail/shop-order-detail.component';
import { OrderService, StoreResponseDto, OrdersListDto } from 'src/generated_client'
import { AuthService } from 'src/app/services/auth/auth.service';
import { MatTableDataSource } from '@angular/material/table';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({
  selector: 'app-cancelled-shop-orders',
  templateUrl: './cancelled-shop-orders.component.html',
  styleUrls: ['./cancelled-shop-orders.component.css']
})

export class CancelledShopOrdersComponent implements OnInit {

  private currentStore: StoreResponseDto = {};
  orderList: OrdersListDto[] = [];
  dataSource = new MatTableDataSource();

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private orderService: OrderService,
    private authService: AuthService,
    private snack: SnackBarService
  ) { }

  displayedColumns: string[] = ['id', 'comercio', 'usuario', 'direccion', 'items', 'opciones'];

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.currentStore = this.authService.currentUserStore();
    this.dataSource.filterPredicate = function (data: any, filter: string): boolean {
      return data.cdOrder.toString().includes(filter)
    };
    this.getCancelledOrder();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openOrder(idOrder: number) {
    let order = this.orderList.find(x => x.cdOrder == idOrder);
    let items = order?.itemInOrderOutputDtos;
    this.dialog.open(ShopOrderDetailComponent, {
      data: {
        items: items,
        delivery: order?.qtDCharges,
        discount: order?.qtDiscount,
        discountItemValue: order?.qtItemsDiscountedTotal,
        total: order?.qtTotal,
        notes: order?.dsNotes
      }
    });
  }

  private getCancelledOrder() {

    this.orderService.apiOrderGetAllCancelledByStoreGet(this.currentStore.cdStore).subscribe(x => {
      this.orderList = x;
      this.dataSource.data = this.orderList
    },
      err => {
        this.snack.openSnackBar(err.error.error, "Aceptar");
      }
    )
  };
}
